<template>
  <div class="control-number-card">
    <p class="control-number-card_title">
      {{ $t('增加數量') }}<span class="red">*</span>
    </p>
    <div class="control-number-card_content-wrap">
      <div
        class="control-number-card_button"
        @click="$_reduceClick()"
      >
        <i class="icon-reduce button-icon" />
      </div>
      <input
        type="number"
        :value="value"
        class="control-number-card_number"
        onkeydown="return event.keyCode !== 69"
        @input="$_changeValue($event)"
      >
      <div
        class="control-number-card_button left"
        @click="$_addClick()"
      >
        <i class="icon-add button-icon" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ControlNumberCard",
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({}),
  mounted() {},
  methods: {
    $_addClick() {
      let number = this.value + 1;
      this.$emit("input", number);
    },
    $_reduceClick() {
      let number;
      if (this.value === 1) {
        return;
      }
      number = this.value - 1;
      this.$emit("input", number);
    },
    $_changeValue($event) {
      let number = parseInt($event.target.value);
      if (!$event.target.value) {
        number = 1;
        $event.target.value = 1;
      }
      this.$emit("input", number);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/control-number-card";
</style>